import { render, staticRenderFns } from "./UnmatchedData.vue?vue&type=template&id=c042e9c4"
import script from "./UnmatchedData.vue?vue&type=script&lang=js"
export * from "./UnmatchedData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports